/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_BreadthInputs */

const en_mk_cmp_r_breadth = /** @type {(inputs: Mk_Cmp_R_BreadthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feature breadth`)
};

const id_mk_cmp_r_breadth = /** @type {(inputs: Mk_Cmp_R_BreadthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luas fitur`)
};

/**
* | output |
* | --- |
* | "Feature breadth" |
*
* @param {Mk_Cmp_R_BreadthInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_breadth = /** @type {((inputs?: Mk_Cmp_R_BreadthInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_BreadthInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_breadth(inputs)
	return en_mk_cmp_r_breadth(inputs)
});